$(() => {
	$('[data-total]').on('change', function () {
		new ArticlePriceCalculation($($(this).data('total')));
	});
});

class ArticlePriceCalculation {
	constructor(total) {
		this.totalOutput = total;
		this.summands = $('[data-total="#' + total.attr('id') + '"]')

		this.updateTotal();
	}

	updateTotal() {
		const sum = this.calculateSum();
		const price = this.formatPrice(sum);

		this.totalOutput.html(price);
	}

	calculateSum() {
		let price = this.totalOutput.data('price');
		const quantity = this.summands.filter('[data-quantity]').val();
		console.log(this.summands);

		this.summands.filter('[data-price]:checked').each(function () {
			price += $(this).data('price');
		});

		return price * quantity;
	}

	formatPrice(price) {
		const decimalSeparator = this.totalOutput.data('decimalseparator');
		const thousandsSeparator = this.totalOutput.data('thousandsseparator');
		const currencySign = this.totalOutput.data('currencysign');

		let parts = price.toFixed(2).split('.');
		let number = parts[0];
		let decimalPlaces = parts[1];

		if (number >= 1000) {
			number = number.slice(0, -3) + thousandsSeparator + number.slice(-3);
		}

		return number + decimalSeparator + decimalPlaces + currencySign;
	}
}
